import {
    mdiAccountCircleOutline,
    mdiAirplaneTakeoff,
    mdiAlphaSBoxOutline,
    mdiAlphaWCircleOutline,
    mdiBookOutline,
    mdiBriefcaseOutline,
    mdiCheckboxMultipleBlankOutline,
    mdiCircleSlice5,
    mdiCloudOutline,
    mdiDotsCircle,
    mdiLicense,
    mdiMessageQuestionOutline,
    mdiPyramid,
    mdiStarCircleOutline,
} from '@mdi/js'

import { IWidgetConfig, TIntegratedSystems } from '@/types/tasksApprovals'

export const widgetsConfig = (systemID: TIntegratedSystems): IWidgetConfig => {
    switch (systemID) {
        case 'MY_HOSTING':
            return {
                id: 'MY_HOSTING',
                color: 'linear-gradient(-135deg, rgb(237, 121, 107) 0%, rgb(215, 68, 57) 100%)',
                icon: {
                    name: mdiDotsCircle,
                },
            }
        case 'SERVICE_NOW':
            return {
                id: 'SERVICE_NOW',
                color: 'linear-gradient(-135deg, rgb(141, 184, 97) 0%, rgb(84, 130, 50) 100%)',
                icon: {
                    name: mdiAccountCircleOutline,
                },
            }
        case 'SERVICE_NOW_CHANGES':
            return {
                id: 'SERVICE_NOW_CHANGES',
                color: 'linear-gradient(-135deg, rgb(141, 184, 97) 0%, rgb(84, 130, 50) 100%)',
                icon: {
                    name: mdiAccountCircleOutline,
                },
            }
        case 'SCHEDULED_CHANGE_REQUESTS':
            return {
                id: 'SCHEDULED_CHANGE_REQUESTS',
                color: 'linear-gradient(-135deg, rgb(141, 184, 97) 0%, rgb(84, 130, 50) 100%)',
                icon: {
                    name: mdiAccountCircleOutline,
                },
            }
        case 'SAIL_POINT':
            return {
                id: 'SAIL_POINT',
                color: 'linear-gradient(-135deg, rgb(240, 73, 154) 0%, rgb(220, 35, 97) 100%)',
                icon: {
                    name: mdiPyramid,
                },
            }
        case 'SHAREPOINT':
            return {
                id: 'SHAREPOINT',
                color: 'linear-gradient(-135deg, rgb(78, 136, 205) 0%, rgb(38, 80, 159) 100%)',
                icon: {
                    name: mdiCloudOutline,
                },
            }
        case 'SAIL_POINT_CERT':
            return {
                id: 'SAIL_POINT_CERT',
                color: 'linear-gradient(-135deg, rgb(158, 148, 208) 0%, rgb(101, 91, 163) 100%)',
                icon: {
                    name: mdiLicense,
                },
            }
        case 'SAIL_POINT_CERT_DECISION':
            return {
                id: 'SAIL_POINT_CERT_DECISION',
                color: 'linear-gradient(-135deg, rgb(158, 148, 208) 0%, rgb(101, 91, 163) 100%)',
                icon: {
                    name: mdiLicense,
                },
            }
        case 'MY_LEARNING':
            return {
                id: 'MY_LEARNING',
                color: 'linear-gradient(-135deg, rgb(237, 121, 107) 0%, rgb(215, 68, 57) 100%)',
                icon: {
                    name: mdiBookOutline,
                },
            }
        case 'MY_LEARNING_RO':
            return {
                id: 'MY_LEARNING_RO',
                color: 'linear-gradient(-135deg, rgb(237, 121, 107) 0%, rgb(215, 68, 57) 100%)',
                icon: {
                    name: mdiBookOutline,
                },
            }
        case 'GRP':
            return {
                id: 'GRP',
                color: 'linear-gradient(-135deg, rgb(133, 101, 200) 0%, rgb(80, 51, 142) 100%)',
                icon: {
                    name: mdiStarCircleOutline,
                },
            }
        case 'WORKDAY_LEAVE_REQUESTS':
            return {
                id: 'WORKDAY_LEAVE_REQUESTS',
                color: 'linear-gradient(-135deg, rgb(84, 217, 205) 0%, rgb(41, 182, 170) 100%)',
                icon: {
                    name: mdiAlphaWCircleOutline,
                },
            }
        case 'WORKDAY_LEAVE_TASKS':
            return {
                id: 'WORKDAY_LEAVE_TASKS',
                color: 'linear-gradient(-135deg, rgb(84, 217, 205) 0%, rgb(41, 182, 170) 100%)',
                icon: {
                    name: mdiAlphaWCircleOutline,
                },
            }
        case 'SAP_GRC_ACCESS_REQUEST':
            return {
                id: 'SAP_GRC_ACCESS_REQUEST',
                color: 'linear-gradient(-135deg, rgb(64, 100, 186) 0%, rgb(38, 59, 110) 100%)',
                icon: {
                    name: mdiAlphaSBoxOutline,
                },
            }
        case 'SAP_LEAVE_REQUEST':
            return {
                id: 'SAP_LEAVE_REQUEST',
                color: 'linear-gradient(-135deg, rgb(64, 100, 186) 0%, rgb(38, 59, 110) 100%)',
                icon: {
                    name: mdiCircleSlice5,
                },
            }
        case 'FIELDGLASS_TIMESHEET':
            return {
                id: 'FIELDGLASS_TIMESHEET',
                color: 'linear-gradient(44.36deg, #B28F2E 35.01%, #EFC243 92%, #F2C444 92.03%)',
                icon: {
                    name: mdiCheckboxMultipleBlankOutline,
                },
            }
        case 'FIELDGLASS_COMPLEMENTARY_WORKER':
            return {
                id: 'FIELDGLASS_COMPLEMENTARY_WORKER',
                color: 'linear-gradient(225.09deg, #6EDCF3 7.17%, #0996B3 66.55%)',
                icon: {
                    name: mdiBriefcaseOutline,
                },
            }
        case 'TNE':
            return {
                id: 'TNE',
                color: 'linear-gradient(48.37deg, #336E13 46.81%, #589B35 92.74%)',
                icon: {
                    name: mdiAirplaneTakeoff,
                },
            }

        default:
            return {
                id: 'DEFAULT',
                color: 'linear-gradient(-135deg, rgb(182, 176, 171) 0%, rgb(102, 88, 80) 100%)',
                icon: {
                    name: mdiMessageQuestionOutline,
                },
            }
    }
}
